import { createFileRoute } from '@tanstack/react-router';

import { PublishedPage } from '@/pages/blood-report/published';

export const Route = createFileRoute('/blood-report/_role-guard/$id/published')({
  component: PublishedPage,
});
